module.exports = __webpack_public_path__ + "static/media/TheHiddenDragonBookCover.449e9894.jpg";